import axiosInstance from './axiosInstance';

const getBooks = async ({ token, language }) => {
  try {
    const response = await axiosInstance.post(
      '/books',
      language ? { language } : {},
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export { getBooks };
